import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingSpinner from '../common/LoadingSpinner';

// Landing route after the backend Google callback redirects here. The session
// (refresh) cookie is already set; we just exchange it for an access token and
// load the profile, then route into the app.
const GoogleCallback = () => {
  const { completeGoogleLogin } = useAuth();
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const ran = useRef(false); // guard against React 18 StrictMode double-invoke

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    (async () => {
      const result = await completeGoogleLogin();
      if (result.success) navigate('/', { replace: true });
      else { setFailed(true); navigate('/login?error=google_failed', { replace: true }); }
    })();
  }, [completeGoogleLogin, navigate]);

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-24">
      <LoadingSpinner />
      <p className="text-sm text-ink-500">{failed ? 'Sign-in failed, redirecting…' : 'Finishing sign-in…'}</p>
    </div>
  );
};

export default GoogleCallback;
